import { assertNever } from 'owa-assert';
import { FilePickerViewType } from 'owa-filepicker';
import {
    ATTACHMENTS_FILE_PICKER_VIEW_TYPE_LIST as LIST,
    ATTACHMENTS_FILE_PICKER_VIEW_TYPE_TILE as TILE,
    ATTACHMENTS_FILE_PICKER_VIEW_TYPE_GROUPS as GROUPS,
} from './constants';

export default function getFilePickerViewTypeValue(viewType: FilePickerViewType): number {
    switch (viewType) {
        case FilePickerViewType.List:
            return LIST;
        case FilePickerViewType.Tile:
            return TILE;
        case FilePickerViewType.Groups:
            return GROUPS;
        default:
            return assertNever(viewType);
    }
}
